// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Box, Card, Flex, type MantineSize, Title } from '@mantine/core';

type Props = {
  icon: ReactNode;
  title: string;
  belowTitle?: ReactNode;
  endSection?: ReactNode;
  /** @defaultValue 'lg' */
  radius?: MantineSize;
};

export const EvolveProductCard = ({ icon, title, belowTitle, endSection, radius = 'lg' }: Props) => (
  <Card withBorder radius={radius}>
    <Flex direction="row" align="center" gap="md">
      {icon}
      <Box flex={1}>
        <Title order={5}>{title}</Title>
        {belowTitle}
      </Box>
      {endSection}
    </Flex>
  </Card>
);
